import React from 'react';
import { Popover } from 'antd';
import styles from './label.module.scss';
import clsx from 'clsx';
import ConditionalRender from '../ConditionalRender';

interface LabelProps {
  label?: string;
  required?: boolean;
  className?: string;
  name?: string;
  infoPopover?: React.ReactNode;
}

const Label: React.FC<LabelProps> = ({ label, required, className, infoPopover, ...props }) => {
  if (!label) return null;
  return (
    <label {...props} className={clsx(styles.label, className)}>
      {label}
      {required ? <sup className={styles.required}>*</sup> : null}
      <ConditionalRender visible={!!infoPopover}>
        <Popover content={infoPopover} arrow={false} rootClassName={styles.infoOverlay} placement={'rightTop'}>
          <img className={styles.infoIcon} src={'/assets/info-icon.svg'} />
        </Popover>
      </ConditionalRender>
    </label>
  );
};

export default Label;
